import { compose, withProps } from "recompose";
import { graphql } from "react-apollo";
import branchServerClient from "web/core/branchServerClient";

const findCurrentImages = (product, selectedSku) => {
  const selectedConfiguration = product.configurations.find(
    ({ product }) => product && product.sku === selectedSku
  );

  return selectedConfiguration
    ? selectedConfiguration.product.images
    : product.images;
};

const withGalleryImages = (ProductGalleryQuery) =>
  compose(
    graphql(ProductGalleryQuery, {
      options: ({ product }) => ({
        variables: {
          sku: product.sku,
        },
      }),
      props: ({ data, ownProps }) => ({
        loading: data.loading,
        images:
          typeof data.product !== "undefined"
            ? findCurrentImages(data.product, ownProps.selectedSku)
            : [],
      }),
    })
  );

const EnhanceProductGallery = ({ ProductGalleryQuery }) =>
  compose(
    branchServerClient(
      withProps({ loading: true }),
      withGalleryImages(ProductGalleryQuery)
    ),
    withProps(({ images, product }) => {
      return {
        images:
          images?.length > 0
            ? images
            : [{ id: "main", file: product.imageUrl, alt: product.name }],
      };
    })
  );

export default EnhanceProductGallery;
